<template>
	<b-modal
		ref="serieListModal"
		size="xmd"
		hide-footer
		:title="`Listado de series - ${code.code}`"
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<div>
			<b-overlay :show="isLoading">
				<b-row class="mb-1">
					<b-col class="d-flex align-items-center">
						<small class="text-secondary">
							Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
						</small>
					</b-col>
					<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
						<b-pagination
							v-model="pagination.curPage"
							:total-rows="pagination.total"
							:per-page="pagination.perPage"
							first-number
							last-number
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon icon="ChevronLeftIcon" size="18" />
							</template>
							<template #next-text>
								<feather-icon icon="ChevronRightIcon" size="18" />
							</template>
						</b-pagination>
					</b-col>
				</b-row>
				<b-row class="mb-1">
					<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start">
						<label>Mostrar</label>
						<v-select
							v-model="pagination.perPage"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
							style="width: 90px"
						/>
						<label class="mr-2">registros</label>
						<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
					</b-col>
				</b-row>
				<b-table-simple responsive sticky-header="60vh" no-border-collapse>
					<b-thead class="sticky-header" style="white-space: nowrap">
						<b-tr>
							<b-th v-for="field in fields" :key="field.key" :class="field.class">
								{{ field.label }}
							</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<template v-if="knives.length > 0">
							<b-tr v-for="(knife, index) in knives" :key="index">
								<b-td class="text-center">
									{{ knife.series }}
								</b-td>
								<b-td class="text-center">
									{{ knife.initial_size || "-" }}
								</b-td>
								<b-td class="text-center">
									<b-badge pill :variant="'light-' + (knife.status ? 'success' : 'danger')">
										{{ knife.status ? "SÍ" : "NO" }}
									</b-badge>
									<b-form-checkbox
										v-model="knife.status"
										:true-value="1"
										:false-value="0"
										name="check-button"
										switch
										class="mt-1 text-center"
										@change="updateKnife(knife)"
										style="margin-left: 0.5rem"
									/>
								</b-td>
								<b-td class="text-center">
									{{ knife.created_at | myGlobalDayWithHour }}
								</b-td>
								<b-td class="text-center">
									<b-button
										variant="flat-info"
										@click="openKnifeHistory(knife)"
										:disabled="knife.usage_count === 0"
									>
										{{ knife.usage_count }}
									</b-button>
								</b-td>
							</b-tr>
						</template>
						<b-tr v-if="knives.length === 0">
							<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</b-overlay>
			<KnifeHistoryModal
				v-if="showKnifeHistoryModal"
				:knife="selectedKnife"
				@close="showKnifeHistoryModal = false"
			/>
		</div>
	</b-modal>
</template>

<script>
import TournamentKnivesService from "@/views/brain/tournament/views/knives/services/tournament-knives.service.js"
import KnifeHistoryModal from "@/views/brain/tournament/views/knives/components/KnifeHistoryModal.vue"
export default {
	name: "SerieListModal",
	components: { KnifeHistoryModal },
	props: {
		code: {
			type: Object,
			required: true,
		},
	},
	data: () => ({
		showKnifeHistoryModal: false,
		search: "",
		isLoading: false,
		fields: [
			{ key: "serie", label: "SERIE", class: "text-center" },
			{ key: "size", label: "TAMAÑO(cm)", class: "text-center" },
			{ key: "status", label: "ACTIVO", class: "text-center" },
			{ key: "created_at", label: "FECHA DE CREACIÓN", class: "text-center" },
			{ key: "action", label: "USOS", class: "text-center" },
		],
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		knives: [],
		selectedKnife: null,
	}),
	computed: {},
	mounted() {
		this.getKnives()
		this.$refs["serieListModal"].toggle()
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getKnives(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getKnives()
		},
	},
	methods: {
		handleCloseModal() {
			this.$emit("close")
		},
		async updateKnife(knife) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres ${knife.status ? "activar" : "desactivar"} a ${this.code.code}-${
					knife.series
				}?`,
				text: "",
			})
			if (!isConfirmed) {
				knife.status = !knife.status
				return
			}
			const { message } = await TournamentKnivesService.updateStatus(knife.id, {
				status: knife.status ? "Active" : "Inactive",
			})
			this.showSuccessToast(message)
			this.getKnives()
		},
		openKnifeHistory(knife) {
			this.selectedKnife = {
				...knife,
				code: this.code.code,
			}
			this.showKnifeHistoryModal = true
		},
		handleInputSearch() {
			this.getKnives()
		},
		refresh() {
			this.getKnives()
		},
		async getKnives(page = 1) {
			try {
				this.isLoading = true
				const { data } = await TournamentKnivesService.getKnives({
					per_page: this.pagination.perPage,
					page,
					search: this.search,
					knife_code_id: this.code.id,
				})
				this.knives =
					data.data.map((item) => ({
						...item,
						status: item.status == 1 ? true : false,
					})) || []
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.error(`Error fetching knives:`, error)
			} finally {
				this.isLoading = false
			}
		},
	},
}
</script>
<style scoped></style>
